const home = {
	home1: function () {
		var galleryThumbs = new Swiper('.hl-home-1 .gallery-thumbs', {
			spaceBetween: 10,
			slidesPerView: 2,
			loop: true,
			freeMode: true,
			loopedSlides: 4, //looped slides should be the same
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			speed: 2000,
			breakpointsInverse: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false
			},
			breakpoints: {
				992: {
					slidesPerView: 4,
				},
				768: {
					slidesPerView: 3,
				}
			}
		});
		var galleryTop = new Swiper('.hl-home-1 .gallery-top', {
			// spaceBetween: 10,
			loop: true,
			loopedSlides: 4, //looped slides should be the same
			navigation: {
				nextEl: '.hl-home-1 .btn-next',
				prevEl: '.hl-home-1 .btn-prev',
			},
			thumbs: {
				swiper: galleryThumbs,
			},
			speed: 2000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false
			}
		});
	},
	home5: function(){
		$('.hl-home-5 .album-img').lightGallery({
			thumbnail:true,
			animateThumb: true,
			showThumbByDefault: true
		}); 
	},
	homeInit: function () {
		home.home1();
		home.home5();
	}
};
